var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref, watch } from "vue";
import { getCurrentGalaxyHistory } from "@/utils/data";
import DataDialog from "@/components/DataDialog/DataDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDataDialog',
    props: {
        id: null,
        multiple: { type: Boolean, default: false },
        value: { default: "" }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faFolderOpen);
        const title = "Browse Datasets";
        const localHistoryId = ref("");
        const dataDialogOpen = ref(false);
        watch(() => dataDialogOpen.value, () => __awaiter(this, void 0, void 0, function* () {
            localHistoryId.value = "";
            localHistoryId.value = yield getCurrentGalaxyHistory();
        }));
        function onData(result) {
            dataDialogOpen.value = false;
            emit("input", result);
        }
        return { __sfc: true, props, title, localHistoryId, dataDialogOpen, emit, onData, FontAwesomeIcon, DataDialog };
    }
});
